import React, {useCallback, useEffect} from 'react';

import {useMyUserId} from '../../../../../data/hooks/sessionHooks';
import {useTimedDeactivation} from '../useTimedDeactivation';
import BubbleFace, {useBubbleFaceImageSrc} from './inner-components/BubbleFace';
import BubbleInfo from './BubbleInfo/BubbleInfo';
import BubbleMenu from './BubbleMenu/BubbleMenu';
import QuestCircleIcon from './inner-components/border-icons/QuestCircleIcon/QuestCircleIcon';
import styles from './Bubble.module.scss';

function stopPropagation(e) {
    e.stopPropagation();
}

const Bubble = props => {
    const {user, event, onExpandBubble, expandedBubble, infoPosition = 'right'} = props,
        {user_id, participant_id, status} = user,
        isOnline = status == 'online',
        isOffline = status == 'offline',
        isInactive = !isOnline && !isOffline,
        selfId = useMyUserId(),
        isMe = selfId == user_id,
        [isActive, setActive, onMouseActivity] = useTimedDeactivation({}),
        hasAvatar = !!useBubbleFaceImageSrc(user);

    const handleMouseActivity = useCallback(() => {
        if (user_id) {
            onMouseActivity();
            onExpandBubble(user_id);
        }
    }, [onExpandBubble]);

    useEffect(() => {
        if (expandedBubble !== user_id) {
            setActive(false);
        }
    }, [expandedBubble]);

    return (
        <div
            className={[
                styles.Bubble,
                isActive ? styles.expandedBubble : '',
                isOnline ? styles.statusOnline : '',
                isOffline ? styles.statusOffline : '',
                isInactive ? styles.statusInactive : '',
                hasAvatar ? styles.hasAvatar : '',
                // // DEBUG
                // styles.expandedBubble
            ].join(' ')}
            onClick={stopPropagation}
            onMouseOver={handleMouseActivity}
            onMouseMove={handleMouseActivity}>
            {isActive ? <div className={styles.overlayCover} /> : null}
            <div className={styles.bubbleBorder}>
                <QuestCircleIcon className={styles.borderIcon} event={event} user={user} hide={isActive} />
                {/*{isMe ? <InnerCircleIcon className={styles.borderIcon} /> : null}*/}
                <div className={styles.onlineBullet} />
            </div>
            <BubbleFace className={styles.bubbleFace} event={event} user={user} />
            <BubbleMenu className={styles.menu} visible={isActive} event={event} user={user} />
            <BubbleInfo
                className={[styles.info, styles[`infoPosition-${infoPosition}`]].join(' ')}
                visible={isActive}
                infoPosition={infoPosition}
                event={event}
                user={user}
            />
        </div>
    );
};

export default Bubble;
